import axios from 'axios';
import React, { useEffect, useState } from 'react';
import '../TypeList/type.css';
import { deleteObject, getStorage, ref as storageRef } from 'firebase/storage';
import { app } from '../../firebase';
import { useNavigate } from 'react-router-dom';

const PropertyList = () => {
    const [properties, setProperties] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        getProperties();
    }, []);

    const getProperties = () => {
        axios.get('https://pkrealestateapi.onrender.com/property')
            .then(res => {
                console.log(res.data); 
                if (res.status === 200 && res.data.properties) {
                    setProperties(res.data.properties.reverse()); 
                } else {
                    console.error('Unexpected response structure:', res.data);
                    setProperties([]); 
                }
            })
            .catch(err => {
                console.error('API call failed:', err);
            });
    };

    const deleteProperty = (propertyData) => {
        
        if (window.confirm("Are you sure you want to delete this item?")) {
            const storage = getStorage(app);
            const myRef = storageRef(storage, `${propertyData.imageUrl}`);
            deleteObject(myRef)
                .then(() => {
                    return axios.delete(`https://pkrealestateapi.onrender.com/property/${propertyData._id}`, {
                        headers: {
                            'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImlzaGFhbmthbGFudHJlMTIzQGdtYWlsLmNvbSIsImZ1bGxOYW1lIjoiSXNoYWFuIEthbGFudHJlIiwidXNlclR5cGUiOiJhZG1pbiIsImlhdCI6MTcyOTMyMTIyNCwiZXhwIjoxNzYwODU3MjI0fQ.LeYo6S7zQVZbiEiaoAagxa_YKj_SaW93R1py9qrkBck` 
                        }
                    });
                })
                .then(res => {
                    console.log(res);
                    getProperties(); 
                })
                .catch(err => {
                    console.error('Error deleting property:', err);
                });
        }
    };

    return (
        <div className="container">
            {properties.map(data => (
                <div className='typecard' key={data._id}>
                    <p><strong>Name:</strong> {data.name}</p>
                    <img className='type-img' src={data.imageUrl} alt={data.name} />
                    <p><strong>Type:</strong> {data.type}</p>
                    <p><strong>Location:</strong> {data.location}</p>
                    <p><strong>Price:</strong> ₹{new Intl.NumberFormat('en-IN').format(data.price)}</p>
                    <button onClick={() => {navigate('/admin/dashboard/edit-property', {state: {myData: data}})}} className="edit-btn">Edit</button>
                    <button onClick={() => deleteProperty(data)} className="delete-btn">Delete</button>
                </div>
            ))}
        </div>
    );
};

export default PropertyList;